import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {
    generateQrCodeSuccess,
    getProfileError,
    getProfileSuccess,
    saveProfileError,
    saveProfileSuccess
} from "store/reducer/user/profile/reducer";
import {getErrorFromMessage} from "services/utils/utils";
import QRCode from "qrcode";

export function* getProfileSaga() {
    try {
        const data = yield call([api, api.getProfile]);
        yield put(getProfileSuccess(data.data));
    } catch (e) {
        console.log(e);
        yield put(getProfileError(getErrorFromMessage(e)));
    }
}
export function* saveProfileSaga({payload}) {
    try {
        yield call([api, api.saveProfile], payload);
        yield put(saveProfileSuccess());
    } catch (e) {
        console.log(e);
        yield put(saveProfileError(getErrorFromMessage(e)));
    }
}
export function* generateQrCodeSaga({payload}) {
    const {url} = payload;
    const data = yield call(QRCode.toDataURL, url);
    yield put(generateQrCodeSuccess(data));
}